import { render, staticRenderFns } from "./InvED_Invoice_Items.vue?vue&type=template&id=1b89a770"
import script from "./InvED_Invoice_Items.vue?vue&type=script&lang=js"
export * from "./InvED_Invoice_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports